import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, setToken, setUser, type User } from "../api";

export default function Login({ onAuth }: { onAuth: (u: User) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const { token, user } = await api.login(email, password);
      setToken(token);
      setUser(user);
      onAuth(user);
      window.dispatchEvent(new Event("gd-auth-changed"));
      navigate("/", { replace: true });
    } catch (e: any) {
      setErr(e.message || "登入失敗");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card" onSubmit={submit}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
          <div className="logo" style={{ width: 36, height: 36, borderRadius: 8, background: "#06c755", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700 }}>GD</div>
          <div>
            <h1>登入 GD HUB</h1>
            <div className="muted">LINE Webhook 中繼站</div>
          </div>
        </div>
        {err && <div className="error">{err}</div>}
        <div className="field">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="field">
          <label>密碼</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button className="primary" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy ? "登入中…" : "登入"}
        </button>
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 13 }}>
          還沒有帳號？ <Link to="/register">註冊</Link>
        </div>
      </form>
    </div>
  );
}
